import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Role} from '../model/role';
import {SharedPreference} from '../shared-preference/shared-perference';
import {profile} from '../inventory/route';
import {AuthenticationService} from '../services/authentication.service';
import {UserAccessUtils} from "../utils/user-access-utils";
import {GuardUtils} from "../utils/guard";


@Injectable({
  providedIn: 'root'
})
export class DiscountByBrandGuardService implements CanActivate{

  constructor(private router: Router, private authenticationService: AuthenticationService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!SharedPreference.getUser()) {
      this.authenticationService.onLogout(false);
      return false;
    }

    if (SharedPreference.getUser().isRequireChangePassword) {
      this.router.navigate([profile]);
      return false;
    } else {
      const hasAccess = ((Role.hasAdminRole(SharedPreference.getUser()) || Role.hasSupervisorRole(SharedPreference.getUser())) && UserAccessUtils.isUserAllowDiscount(SharedPreference.getUser()) && UserAccessUtils.isUserAllowProduct(SharedPreference.getUser())) || Role.hasVersitaAdmin(SharedPreference.getUser()) || Role.hasVersitaAdmin(SharedPreference.getUser());
      return GuardUtils.handleAccessControl(hasAccess, this.router, state);
    }
  }
}
